export default __webpack_public_path__ + "static/media/B4UStreet.d9c45794.jpeg";